import { fg } from '@atlaskit/platform-feature-flags';

export function createAtlAttributionHeader({
	atlWorkspaceId,
	tenantId,
	product,
}: {
	atlWorkspaceId: string;
	tenantId: string;
	product: string;
}):
	| {
			'atl-attribution': string;
	  }
	| undefined {
	if (!fg('kd_agg_atl_attribution_header')) {
		return;
	}

	const atlAttributionHeader = {
		atlWorkspaceId,
		tenantId,
		product,
	};
	return { 'atl-attribution': JSON.stringify(atlAttributionHeader) };
}
